import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'tw-elements';
import App from './App';
import PdfViewer from './components/core/activityCard/pdfViewer';
import Admin from './pages/admin';
import Community from './pages/community';
import Course from './pages/elearning/course';
import Courses from './pages/elearning/courses';
import CreateLesson from './pages/elearning/createLesson';
import EditLesson from './pages/elearning/editLesson';
import Lesson from './pages/elearning/lesson';
import Evaluation from './pages/evaluation';
import EventDetailsPage from './pages/eventDetails';
import Events from './pages/events';
import Faq from './pages/Faq';
import ForgotPassword from './pages/forgotPassword';
import Home from './pages/homepage';
import { LibraryPage } from './pages/library';
import CohortEnrolment from './features/mfa/pages/CohortEnrolment';
import { YoungConnectRoutes } from './features/young-connect/config/moduleFlag';
import LoginSecondStep from './features/mfa/pages/LoginSecondStep';
import Login from './pages/login';
import Logout from './pages/logout';
import NewPassword from './pages/newPassword';
import NotFound from './pages/NotFound';
import PersonalProfile from './pages/personalProfile';
import { PostPage } from './pages/post';
import Privacy from './pages/privacy';
import PublicProfile from './pages/publicProfile';
import Register from './pages/register';
import TopicDetail from './pages/topicDetails';
import { TopicsOverview } from './pages/topics';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="viewPdf/:url" element={<PdfViewer />} />
        <Route path="login" element={<Login />} />
        <Route path="login/second-step" element={<LoginSecondStep />} />
        <Route path="login/cohort-enrolment" element={<CohortEnrolment />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot" element={<ForgotPassword />} />
        <Route path="new-password/:token" element={<NewPassword />} />
        <Route path="/" element={<App />}>
          <Route path="/" element={<Home />} />
          <Route path="topics" element={<TopicsOverview />} />
          <Route path="topics/:topicId" element={<TopicDetail />} />
          <Route path="library" element={<LibraryPage />} />
          <Route path="library/:fileId" element={<LibraryPage />} />
          <Route path="logout" element={<Logout />} />
          <Route path="courses" element={<Courses />} />
          <Route
            path="courses/:courseId/lessons/:lessonId/update"
            element={<EditLesson />}
          />
          <Route path="courses/:courseId" element={<Course />} />
          <Route
            path="courses/:courseId/lessons/create"
            element={<CreateLesson />}
          />
          <Route
            path="courses/:courseId/lessons/:lessonId/item/:itemIndex"
            element={<Lesson />}
          />
          <Route path="events" element={<Events />} />
          <Route path="events/:eventId" element={<EventDetailsPage />} />
          <Route path="/personalProfile" element={<PersonalProfile />} />
          <Route path="profile/:userId" element={<PublicProfile />} />
          <Route path="admin/:tab" element={<Admin />} />
          <Route path="faq" element={<Faq />} />
          <Route path="privacy-statement" element={<Privacy />} />
          <Route path="community" element={<Community />} />
          <Route path="evaluation" element={<Evaluation />} />
          <Route path="/posts/:postID" element={<PostPage />} />
        </Route>
        {YoungConnectRoutes && (
          <Route
            path="young-connect/*"
            element={
              <Suspense fallback={null}>
                <YoungConnectRoutes />
              </Suspense>
            }
          />
        )}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
